import { createContext } from 'react';

const initialData = {};

export const UserContextForVonage = createContext(initialData, () => {});
